module.exports = __webpack_public_path__ + "img/essentials@2x.3d69169.jpg";